<div class="custom-background">
    <div class="row logo-margin">
        <div class="col-12 text-center">
            <img class="logo" src="./assets/images/logos/logo_bankei.png">
        </div>
    </div>

    <div class="row container-fluid m-0">
        <div class="col-lg-6 col-md-6 col-sm-12 login-container-padding-left my-4">
            <div class="title">PIN enviado por e-mail</div>
            <div class="subtitle">Digite o PIN enviado para seu e-mail e cadastre sua nova senha</div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 login-container-padding-right">
            <form [formGroup]="confirmFormGroup" #confirmForm="ngForm" (ngSubmit)="onSubmit(confirmFormGroup.value)">
                <div class="my-3">
                    <div class="custom-input-container">
                        <input maxlength="6" formControlName="token" id="token" type="text" class="custom-input" />
                        <label class="custom-label" for="token">PIN enviado por E-mail</label>
                    </div>
                    <div *ngIf="form.token.invalid && (form.token.dirty || form.token.touched)"
                        class="custom-text-danger">
                        <div *ngIf="form.token.errors.required">
                            O PIN é obrigatório
                        </div>
                    </div>
                </div>

                <div class="my-3">
                    <div class="custom-input-container">
                        <input onlyNumber maxlength="10" formControlName="senha" id="senha" type="password" class="custom-input" />
                        <label class="custom-label" for="senha">Nova senha
                            <ngx-mat-popover
                                [popoverContent]="popoverContent"
                                [xPosition]="'after'"
                                [yPosition]="'above'"
                                #popover>
                                <i class="fas fa-info-circle pl-2" style="color: white; cursor: pointer;"></i>
                            </ngx-mat-popover>
                        </label>
                    </div>
                    <div *ngIf="form.senha.invalid && (form.senha.dirty || form.senha.touched)"
                        class="custom-text-danger">
                        <div *ngIf="form.senha.errors.required">
                            A senha é obrigatória
                        </div>
                        <div *ngIf="form.senha.errors.minlength">
                            Senha deve conter mais de 6 dígitos
                        </div>
                        <div *ngIf="form.senha.errors.maxlength">
                            Senha deve conter no máximo 10 dígitos
                        </div>
                    </div>
                </div>

                <div class="my-4">
                    <div class="custom-input-container">
                        <input onlyNumber maxlength="10" formControlName="senhaConfirmacao" id="senhaConfirmacao"
                            class="custom-input" type="password" />
                        <label class="custom-label" for="senhaConfirmacao">Confirmar a nova senha</label>
                    </div>
                    <div *ngIf="form.senhaConfirmacao.invalid && (form.senhaConfirmacao.dirty || form.senhaConfirmacao.touched)"
                        class="custom-text-danger">
                        <div *ngIf="form.senhaConfirmacao.errors.required">
                            A senha de confirmação é obrigatória
                        </div>
                        <div *ngIf="form.senhaConfirmacao.errors.mustMatch">
                            As senhas devem coincidir
                        </div>
                    </div>
                </div>



                <div class="row my-2">
                    <div class="col-12 py-4 d-flex justify-content-end">
                        <button [disabled]="!confirmForm.valid" type="submit" class="login-button">
                            <span>Redefinir senha</span>
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>

<ng-template #popoverContent>
    <div class="titlePopover">Critérios de aceitação da senha</div>
    <div class="content">
      <ol>
          <li>A senha deve somente ter números</li>
          <li>A senha deve ter entre 6 a 10 dígitos</li>
          <li>A senha não pode ser parte do CPF, data de nascimento ou número de telefone</li>
          <li>Não é permitido dígitos iguais consecutivos. Exemplo: <span class="passExample">222222</span> ou <span class="passExample">222584</span></li>
          <li>Só é permitido até 2 dígitos sequencias consecutivos. Exemplo: <span class="passExample">238462</span></li>
      </ol>
    </div>
</ng-template>
